import { AdminService } from './../../_services/admin.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bold-emitter',
  templateUrl: './bold-emitter.component.html',
  styleUrls: ['./bold-emitter.component.css']
})
export class BoldEmitterComponent implements OnInit {
  imageSource:any=undefined
  loading=false
  constructor(private adminService:AdminService) { }


  ngOnInit(): void {
  }
  emitCode(){
    this.imageSource=undefined
    this.loading=true
    this.adminService.emitCode().subscribe(
      iValue =>{
        this.loading=false
       this.imageSource = iValue
      }
    )

  }
}
